import ErrorActionTypes from "./action-types.ts";

export const errorState = (payload) => ({
    type: ErrorActionTypes.ERROR,
    payload,
});